import { useState, useEffect, useCallback, useRef } from 'react';
import { supabase } from '../lib/supabase';

const STALE_MS = 20_000;   // repeated refresh() calls within this window are no-ops
const POLL_MS = 60_000;

// Unread notification count for the nav badge.
// Deliberately poll-based — no flow may depend on Realtime firing (Replication
// is a manual dashboard step; see WORKLOG 2026-04-06 lesson).
export function useUnreadCount() {
  const [count, setCount] = useState(0);
  const lastFetchRef = useRef(0);

  const refresh = useCallback(async (force = false) => {
    const now = Date.now();
    if (!force && now - lastFetchRef.current < STALE_MS) return;
    lastFetchRef.current = now;

    const { data, error } = await supabase.rpc('get_unread_notification_count');
    if (error) {
      console.error('get_unread_notification_count:', error);
      return;
    }
    setCount(data ?? 0);
  }, []);

  useEffect(() => {
    refresh(true);

    const interval = setInterval(() => refresh(true), POLL_MS);
    const onVisible = () => {
      if (document.visibilityState === 'visible') refresh();
    };
    document.addEventListener('visibilitychange', onVisible);

    return () => {
      clearInterval(interval);
      document.removeEventListener('visibilitychange', onVisible);
    };
  }, [refresh]);

  return { count, refresh };
}
